import React, { useState, useEffect, useRef } from "react";
import achivement_icon1 from "../../assets/images/svg/achivement_icon1.svg";
import achivement_icon2 from "../../assets/images/svg/achivement_icon2.svg";
import achivement_icon3 from "../../assets/images/svg/achivement_icon3.svg";
import achivement_icon4 from "../../assets/images/svg/achivement_icon4.svg";
import { tiltHandlers } from "../hkianimatica/useTilt";
import "../../styles/animatica.css";
import "../../styles/skilling.css";

const SkillingHero = () => {
  const [counters, setCounters] = useState({
    ongoingTraining: 0,
    studentsPlaced: 0,
    trainingCentres: 0,
    statePresence: 0,
  });
  const [startCounting, setStartCounting] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setStartCounting(true);
          element?.classList.add("an-visible");
          observer.disconnect(); // Stop observing once the animation is triggered
        }
      },
      { threshold: 0.35 } // Trigger well before the section is fully in view
    );

    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (startCounting) {
      const intervals = {
        ongoingTraining: setInterval(() => {
          setCounters((prev) => ({
            ...prev,
            ongoingTraining:
              prev.ongoingTraining < 10000 ? prev.ongoingTraining + 50 : 10000,
          }));
        }, 10),
        studentsPlaced: setInterval(() => {
          setCounters((prev) => ({
            ...prev,
            studentsPlaced:
              prev.studentsPlaced < 1000 ? prev.studentsPlaced + 10 : 1000,
          }));
        }, 20),
        trainingCentres: setInterval(() => {
          setCounters((prev) => ({
            ...prev,
            trainingCentres:
              prev.trainingCentres < 40 ? prev.trainingCentres + 3 : 40,
          }));
        }, 100),
        statePresence: setInterval(() => {
          setCounters((prev) => ({
            ...prev,
            statePresence:
              prev.statePresence < 10 ? prev.statePresence + 1 : 10,
          }));
        }, 200),
      };

      return () => {
        Object.values(intervals).forEach(clearInterval);
      };
    }
  }, [startCounting]);

  const stats = [
    { icon: achivement_icon2, value: counters.ongoingTraining, label: "Ongoing Training" },
    { icon: achivement_icon3, value: counters.studentsPlaced, label: "Students Placed" },
    { icon: achivement_icon4, value: counters.trainingCentres, label: "Training Centres" },
    { icon: achivement_icon1, value: counters.statePresence, label: "State Presence" },
  ];

  return (
    <div className="an-section skilling-home-section py-5" ref={sectionRef}>
      <div className="an-glow an-glow-left" />
      <div className="container py-md-5 position-relative">
        <h5 className="an-reveal an-reveal-d1 text-center fs_44 fw-bold ff_s an-title-gradient d-block mb-0">
          Our Achievements
        </h5>
        <p className="an-reveal an-reveal-d2 text-center fs_24 fw-semibold ff_n mb-0 mt-2 skilling-subtitle">
          In Collaboration with MESC and State Governments
        </p>
        <div className="row justify-content-center mt-4">
          {stats.map((stat, index) => (
            <div key={stat.label} className="col-md-3 col-6 mt-4">
              <div
                className={`an-glass an-tilt an-reveal an-reveal-d${index + 1} h-100 p-4 text-center`}
                {...tiltHandlers}
              >
                <div className="an-icon-halo mx-auto mb-3">
                  <img src={stat.icon} alt={stat.label} />
                </div>
                <h4 className="fs_27 mb-0 ff_s fw-bold skilling-stat-value">
                  {stat.value}+
                </h4>
                <p className="fs_16 ff_n mb-0 mt-1 skilling-stat-label">
                  {stat.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillingHero;
